import React from 'react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import Footer from "../Footer/Footer"
import './contact.scss';

function Contact() {

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".bottom-pulldown", {
            scrollTrigger: {
                trigger: ".bottom-pulldown",
                start: "top 70%",
                end: "90% 90%",
                // toggleActions: "restart none resume reset",
                scrub: true,
                // markers: true
            },
            scaleY: 0,
        })
    }, [])
    

return (
        <section id='contact-section'>
            <div className='contact-section-wrapper'>
                <div className='contact-content'>
                    
                    <div className='contact-main'>
                        <h1 className='header'>Would love to hear from<br/>you ↓.</h1>
                        <h2 className='sub-header'>I am currently interested in a “Software development intern role“, but still open to other opportunities. However, if you have other requests or questions, don’t hesitate to use the form.</h2>
                        <form className='contact-form' action="https://formsubmit.co/2da81271abb1397abf9452ceb40b325d" method="POST">
                        
                        {/* Form Configuration */}
                        <input type="text" name="_honey" style={{ display: "none"}} />
                        <input type="hidden" name="_captcha" value="false" />
                        <input type="hidden" name="_next" value="https://portfolioapr.netlify.app/" />
                        <input type="hidden" name="_subject" value="Alert! New Message" />
                        {/* Form Input */}
                        <input className='input-field input-name' type="text" name="Name" required placeholder='Name'/>
                        <input className='input-field input-email' type="email" name="Email" required placeholder='Email'/>
                        <input className='input-field input-subject' type="text" name="Subject" required placeholder='Subject'/>
                        <textarea className='input-field input-message' type="text" name="Message" required placeholder='Message'/>
                        <div className='submit-btn-div'><button type="submit"><span>Submit</span><svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="m.819 50.513 8.307 8.238 38.423-38.454-.059 28.89h11.638V.424H10.47l-.14 11.564h28.983L.819 50.513Zm55.31-47.09v42.764V3.424Z" fill="currentColor"></path></svg></button></div>
                    </form> 
                    </div>
                    <div className='all-links'>
                        <h3>QUICK LINKS</h3>
                        <div className='quick-links'>
                            <Link to="/"><span className='block-anim'>Home</span></Link>
                            <span className='line'></span>
                            <Link to="/about"><span className='block-anim'>About</span></Link>
                            <span className='line'></span>
                            <Link to="/projects"><span className='block-anim'>Projects</span></Link>
                            <span className='line'></span>
                            <Link to="/skills"><span className='block-anim'>Skills</span></Link>
                        </div>
                        <h3>EXTRAS</h3>
                        <div className='extra-links'>
                            <a href="./assets/Aprameya S - Resume.pdf" name="Download Resume" download className='resume-btn'><span className='block-anim'>RESUME</span></a>
                        </div>
                    </div>
                    
                </div>
                <Footer />
            </div>
            <div className='bottom-pulldown'></div>
        </section>  
    )   
}
export default Contact;
